import * as Backbone from "backbone";
import { CachingCollection } from "./_BaseCollection";

interface ReportFilesOptions {
    organizationId: number;
}

export class ReportFilesCollection extends CachingCollection<Backbone.Model> {
    public organizationId: number;

    constructor(initialModels?: Object[] | any[], options?: ReportFilesOptions) {
        super(initialModels, options);
        this.organizationId = options.organizationId;
    }

    url = () => {
        return window.location.origin + "/api/v1/reports/files/" + this.organizationId;
    };

    downloadReport = () => {
        return window.location.origin + "/api/v1/reports/files/download";
    };

    comparator = (model) => {
        return model.get("id");
    };
}



// WEBPACK FOOTER //
// ./srv/public/js/collections/ReportFiles.ts